import React from 'react';

import './style.sass';

type Props = {
    userName: string,
    email: string,
    userNameClassName?: string,
    emailClassName?: string,
};

export const UserInfo = ({ userName, email, userNameClassName, emailClassName }: Props) => {
    const userNameClass = userNameClassName ? userNameClassName : 'p1-medium dark-violet';
    const emailClass = emailClassName ? emailClassName : 'p2-regular grey-1';

    return (
        <div className="user-info">
            <span className={userNameClass}>{userName}</span>
            <span className={emailClass}>{email}</span>
        </div>
    );
};
